import React from "react";

export const MdAirplane = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M448 336v-40L288 192V79.2c0-17.7-14.8-31.2-32-31.2s-32 13.5-32 31.2V192L64 296v40l160-48v113.6l-48 31.2V464l80-16 80 16v-31.2l-48-31.2V288l160 48z"/></svg>) as JSX.Element;
